import {createContext, useContext, useState, useEffect} from 'react'
import {useNavigate} from 'react-router-dom'

export const createContextApi = createContext()

export const useContextApi = () => {
	return useContext(createContextApi)
}

export const ContextApi = ({ children }) => {
	const [nameUser, setNameUser] = useState('')
	const [noPelanggan, setNoPelanggan] = useState('')
	const [idUser, setIdUser] = useState('')
	const logged = localStorage.getItem('logged_in');

	const [activeMenu, setActiveMenu] = useState(0)

	const [limitData, setLimitData] = useState(5)

	const token = 'Bearer ' + window.localStorage.getItem('token')

	let navigate = useNavigate()

	useEffect(() => {
		const idUser = localStorage.getItem('idUser');
		const noPelanggan = localStorage.getItem('noPelanggan');
		const name = localStorage.getItem('nama');

		setNameUser(name);
		setNoPelanggan(noPelanggan);
		setIdUser(idUser);
	}, [])

	const handleLogout = () => {
		// const isLogout = confirm('Apakah anda ingin keluar ?')

		// if(isLogout){
			setNameUser('')

			localStorage.removeItem('nama');
			localStorage.removeItem('idUser');
			localStorage.removeItem('noPelanggan');
			localStorage.removeItem('logged_in');

			navigate('/')
		// }

	}

	return (
		<createContextApi.Provider value={{nameUser, idUser, noPelanggan, logged, handleLogout, activeMenu, setActiveMenu, limitData, setLimitData, token}}>
			{children}
		</createContextApi.Provider>
	)
}

export default ContextApi